import { useCallback, useEffect, useState } from "react";
import OrderTypeWayPayment from "./OrderTypeWayPayment";
import { Box, Button, TextField, Typography } from "@mui/material";

interface Props {
  index: number;
  data: any;
  onUpdate: any;
}
const OrderTypeWay: React.FC<Props> = ({ index, data, onUpdate }) => {
  const [state, setState] = useState(data);
  const [btnDisable , setBtnDisable] = useState(true);

  // console.log({state});
  

  const handleUpdateField = (field: any, value: any) => {
    // onUpdate({ ...data, [field]: value });
    setState((prev: any) => ({ ...prev, [field]: value }));
    setBtnDisable(false);
  };

  const handleSave = ()=>{
    onUpdate(state);
    setBtnDisable(true)
  }

  //   console.log({state});

  const handleUpdatePayments = (newPayment: any) => {
    console.log({newPayment});
    
    setState((prev: any) => {
      const updatedPayments = prev.payments.map((payment: any) =>
        Object.keys(payment).some((key) =>
          Object.keys(newPayment).includes(key)
        )
          ? { ...payment, ...newPayment } // Replace the matching object
          : payment
      );

      // Check if the new payment was added to the updatedPayments
      const isReplaced = updatedPayments.some((payment: any) =>
        Object.keys(payment).some((key) =>
          Object.keys(newPayment).includes(key)
        )
      );

      // If no match, add the new payment
      if (!isReplaced) {
        updatedPayments.push(newPayment);
      }

      console.log({updatedPayments});
      

      return { ...prev, payments: updatedPayments };
    });
  };

  useEffect(()=>{
    onUpdate(state)
  },[state])

  const handleAddPayment = () => {
    setState({
      ...state,
      payments: [
        ...state.payments,
        {
          [`key${data.payments.length}`]: "",
          [`value${data.payments.length}`]: "",
        },
      ],
    });
  };

  return (
    <Box
      style={{
        // marginBottom: "20px",
        border: "1px solid #ccc",
        padding: "10px",
      }}
    >
      <Typography variant="h5" fontWeight={500}>
        Order Type Way {index + 1}
      </Typography>
      <Box display={"flex"} gap={1} paddingY={1}>
        <TextField
          type="text"
          placeholder="tander name"
          defaultValue={data.key}
          onChange={(e) => handleUpdateField("key", e.target.value)}
          size="small"
        />
        <TextField
          type="text"
          placeholder="tender ID"
          defaultValue={data.value}
          onChange={(e) => handleUpdateField("value", e.target.value)}
          size="small"
        />
        <TextField
          type="text"
          placeholder="Price Sequence"
          defaultValue={data.priceSequence}
          onChange={(e) => handleUpdateField("priceSequence", e.target.value)}
          size="small"
        />
        <Button variant="outlined" onClick={handleSave} disabled={btnDisable}>
          Save
        </Button>
      </Box>
      <Box paddingX={1}>
        <Typography sx={{ fontSize: "18px" }}>Payments</Typography>
        {state?.payments?.map((payment: any, idx: number) => (
          <OrderTypeWayPayment
            key={idx}
            index={idx}
            data={payment}
            onUpdate={(updatedPayment: any) =>
              handleUpdatePayments(updatedPayment)
            }
          />
        ))}
        <Button
          style={{ marginLeft: "20px", marginBottom: "10px" }}
          variant="outlined"
          onClick={handleAddPayment}
        >
          Add Payment
        </Button>
      </Box>
    </Box>
  );
};

export default OrderTypeWay;
